import React, { useCallback } from 'react';

import Button from 'components/form/Button.component';
import logger from 'utils/logger.util';

const L = logger('WizardButton');

const WizardButton = ({ onNext, value, wizardModalState, ...extra }) => {
  const handleClick = useCallback(
    // this handler shouldn't need more props, but if it does, they should be destructured out of the extra ones first
    () => onNext(L.debug('handleClick()', { value, wizardModalState })),
    [onNext, value, wizardModalState],
  );

  // extra props will not include the modal specific ones in order to not make React complain
  return <Button {...extra} onClick={handleClick} />;
};

// noinspection JSUnusedGlobalSymbols
export default WizardButton;
